<template>
  <table class="table table-bordered text-nowrap">
    <thead class="thead-dark">
      <tr>
        <th>№</th>
        <th>Начало <small>(UTC+3)</small></th>
        <th>Конец <small>(UTC+3)</small></th>
      </tr>
    </thead>
    <tr
      v-for="(period, index) in periods"
      :key="index"
    >
      <td class="num">{{index + 1}}</td>
      <td>{{period.begin | getMomentMinStr}}</td>
      <td>{{period.end   | getMomentMinStr}}</td>
    </tr>
  </table>
</template>

<script>
export default {
  name: 'PeriodsTable',

  props: {
    periods: {
      type: Array,
      required: true,
    }
  },
};
</script>

<style scoped>
td.num {
  text-align: right;
}

table {
  width: 1px;
}
</style>
